import { FunctionComponent, useEffect, useState } from 'react';

// Components
import Image from '@Components/Utils/Image';

// Utils
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';
import { useAccountContext } from '@Components/Account/Contexts';
import { useDataTransfer } from '@Components/Utils/DataTransfer';
import { getHttpErrorMessage, useHttpContext } from '@Libs/http';

// Styles
import styles from './ButtonAdvisory.module.scss';
import { useAlertContext } from '@Components/Alert/Context';

// Apis
import doctorApi from '@Libs/api/user/doctor';
import { handleOpenApp } from '@Libs/utils';

// Types
import Doctor from '@Pages/tra-cuu/bac-si/[id]/DoctorPage';

interface ButtonAdvisory {
    hasButton?: boolean;
    className?: string;
}

const ButtonAdvisory: FunctionComponent<ButtonAdvisory> = (props) => {
    const { alert } = useAlertContext();
    const { userHttp } = useHttpContext();
    const { summary } = useAccountContext();
    const { deviceType } = useViewDetected();
    const { doctor } = useDataTransfer<Doctor>();
    const [isBookmarked, setBookmarked] = useState<boolean>(doctor.isBookmarked);

    useEffect(() => {
        setBookmarked(doctor.isBookmarked);
    }, [doctor.isBookmarked]);

    const className = classnames([
        styles.wrapper,
        {
            [styles.mobile]: ['mobile', 'tablet'].includes(deviceType),
        },
        props.className,
    ]);

    const handleBookmark = () => {
        try {
            doctorApi(userHttp).bookmark(doctor.id);
            setBookmarked(true);
        } catch (error) {
            alert({
                type: 'error',
                title: 'Đã xảy ra lỗi',
                text: getHttpErrorMessage(error),
            });
        }
    };

    const handleUnBookmark = () => {
        try {
            doctorApi(userHttp).unBookmark(doctor.id);
            setBookmarked(false);
        } catch (error) {
            alert({
                type: 'error',
                title: 'Đã xảy ra lỗi',
                text: getHttpErrorMessage(error),
            });
        }
    };

    return (
        <div className={className}>
            {props.hasButton && (
                <a
                    className={styles.btn_chat}
                    onClick={handleOpenApp('edoctor://consultation_list')}
                    href={deviceType === 'desktop' ? 'https://dl.edoctor.io/taiapp' : `edoctor://doctor_detail/${doctor?.id}`}
                >
                    Tư vấn ngay
                </a>
            )}

            {summary && <Image className={styles.icon_heart} src={`/assets/tra-cuu/bac-si/heart_${isBookmarked ? 'on' : 'off'}.png`} onClick={isBookmarked ? handleUnBookmark : handleBookmark} />}
        </div>
    );
};

ButtonAdvisory.defaultProps = {
    className: '',
    hasButton: true,
};

export default ButtonAdvisory;
